export const PartnerTypeAndPlatform = {
	'marketplace': 'Marketplace',
	'datacloud': 'DataCloud'
};
